import { isFunction, isObject } from 'lodash';
import memoize from 'memoize-one';
/**
 * Global window object utilities
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Window
 */
export const hasPerformance = memoize(() => hasWindow() &&
    isObject(window.performance) &&
    isFunction(window.performance.mark) &&
    isFunction(window.performance.measure));
/**
 * Check existence of global window object
 */
export const hasWindow = () => typeof window !== 'undefined' && !!window.document;
/**
 * Checks and returns the protocol property of global window object's Location property
 */
export const protocol = () => (hasWindow() ? window.location.protocol : '');
/**
 * Checks and returns the href attribute of global window object's Location property
 * @returns {string}
 */
export const href = (fallback = 'server') => hasWindow() ? window.location.href : fallback;
/**
 * Checks and return the origin attribute of global window object's Location property
 * @returns {string}
 */
export const origin = () => {
    if (!hasWindow())
        return '';
    if (window.location.origin)
        return window.location.origin;
    // for IE and older browsers
    return (window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : ''));
};
/**
 * Reload the browser page
 */
export const reload = () => {
    var _a;
    if (hasWindow())
        (_a = window.location) === null || _a === void 0 ? void 0 : _a.reload(true);
};
